import { Alert, ButtonIcon, Link, Text } from '@backstage/ui';
import { useState } from 'react';
import { RiFileCopyLine, RiCheckLine } from '@remixicon/react';
import { scaffolderGithubEmuTranslationRef } from '../translation';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

interface CommonStatusAlertProps {
  pendingInvitationUrl?: string;
  userLabel: string;
}

export const CommonStatusAlert = ({
  pendingInvitationUrl,
  userLabel,
}: CommonStatusAlertProps) => {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslationRef(scaffolderGithubEmuTranslationRef);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(pendingInvitationUrl ?? '');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Alert
      status="warning"
      icon
      title={t('emailStatusPicker.pendingInvitation.title', {
        user: userLabel,
      })}
      customActions={
        <ButtonIcon
          size="small"
          variant="tertiary"
          icon={copied ? <RiCheckLine /> : <RiFileCopyLine />}
          aria-label={
            copied
              ? t('emailStatusPicker.pendingInvitation.copiedLabel')
              : t('emailStatusPicker.pendingInvitation.copyLabel')
          }
          onClick={handleCopyLink}
        />
      }
      description={
        <div className="copyRow">
          {t('emailStatusPicker.pendingInvitation.description')}
          <Link
            href={pendingInvitationUrl}
            target="_blank"
            rel="noopener"
            color="info"
          >
            <Text variant="body-small" color="info">
              {t('emailStatusPicker.pendingInvitation.acceptLink')}
            </Text>
          </Link>
        </div>
      }
    />
  );
};
